export function disableAnimations() {
  if (typeof window === 'undefined') {
    return false;
  }
  return (
    !('animate' in document.documentElement) || (navigator && /iPhone OS (8|9|10|11|12|13)_/.test(navigator.userAgent))
  );
}
